import type { ReactNode } from 'react';
import { AlertTriangle, RotateCw } from 'lucide-react';

export function StateCard({
  icon,
  warning = false,
  title,
  children,
}: {
  icon: ReactNode;
  warning?: boolean;
  title: string;
  children?: ReactNode;
}) {
  return (
    <div className="card">
      <div className="card-body">
        <div className="empty">
          <div className={`e-icon${warning ? ' e-icon-warning' : ''}`}>{icon}</div>
          <h3>{title}</h3>
          {children}
        </div>
      </div>
    </div>
  );
}

export function LoadFailure({ error, onRetry }: { error: unknown; onRetry: () => void }) {
  return (
    <StateCard warning icon={<AlertTriangle aria-hidden="true" />} title="This could not be loaded">
      <p>{error instanceof Error ? error.message : 'Unexpected error.'}</p>
      <p className="empty-actions">
        <button type="button" className="btn btn-secondary" onClick={onRetry}>
          <RotateCw aria-hidden="true" /> Retry
        </button>
      </p>
    </StateCard>
  );
}

export function LoadingCard({ label }: { label: string }) {
  return (
    <div className="card" aria-busy="true" aria-label={label}>
      <div className="card-body">
        {[0, 1, 2, 3].map((i) => (
          <span key={i} className="skeleton-bar users-skeleton-line" />
        ))}
      </div>
    </div>
  );
}

/** A Configuration tab's own description and actions, under the tab strip. */
export function TabToolbar({ description, children }: { description?: string; children?: ReactNode }) {
  if (!description && !children) return null;
  return (
    <div className="tab-toolbar">
      {description && <p className="hint">{description}</p>}
      {children && <div className="page-actions">{children}</div>}
    </div>
  );
}

export function FormError({ error }: { error: unknown }) {
  if (!error) return null;
  return (
    <div className="alert alert-warning form-alert" role="alert">
      <AlertTriangle aria-hidden="true" />
      <div className="a-body">{error instanceof Error ? error.message : String(error)}</div>
    </div>
  );
}
